import React from 'react';
import styles from './TextEffectsRetro.scss';
import type { TextEffectsSharedProps } from '../../TextEffectsShared/TextEffectsShared.types';
import TextEffectsShared from '../../TextEffectsShared/viewer/TextEffectsShared';
import { TestIds } from '../constants';

export type TextEffectsRetroProps = TextEffectsSharedProps;

const TextEffectsRetro: React.FC<TextEffectsSharedProps> = props => {
  const { text } = props;

  return (
    <TextEffectsShared {...props}>
      <div
        className={styles.wrapper}
        data-testid={TestIds.viewer.container}
        data-text={text}
      >
        <div data-testid={TestIds.viewer.text} className={styles.text}>
          {text}
        </div>
      </div>
    </TextEffectsShared>
  );
};

export default TextEffectsRetro;
